import { beneficios } from './mock/beneficiosMock.js';

angular.module('Toke').factory('beneficiosRepository', function ($q) {

    function getBeneficios() {
        return $q.resolve(beneficios)
    }

    // para lista futura
    // function getBeneficiosFromList() {

    //     const listUrl =
    //         baseUrl +
    //         "/_api/web/lists/getbytitle('Intro')/items" +
    //         "?$select=Title,Url,ParentId,Order,IsActive" +
    //         "&$orderby=Order asc";

    //     return $http({
    //         method: 'GET',
    //         url: listUrl,
    //         headers: {
    //             Accept: 'application/json;odata=nometadata'
    //         }
    //     }).then(function (response) {
    //         return response.data.value;
    //     });
    // }



    return {
        getBeneficios: getBeneficios
    };

});

